import "./navigation.css";
import Header from "./Header/index";
import navigations from "./data";
export default function navigation() {
  return <Header items={navigations} logo={null} navPosition="center" />;
}
